/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerlijn_Balanceren2Inputs */

const nl_enums_leerlijn_balanceren2 = /** @type {(inputs: Enums_Leerlijn_Balanceren2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balanceren`)
};

/**

* @param {Enums_Leerlijn_Balanceren2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerlijn_balanceren2 = /** @type {((inputs?: Enums_Leerlijn_Balanceren2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerlijn_Balanceren2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerlijn_balanceren2(inputs)
});
export { enums_leerlijn_balanceren2 as "enums.Leerlijn.Balanceren" }